import React from 'react';
export function TopBar() {
  return <div className="sticky top-0 z-40 flex min-h-[38px] w-full items-center justify-center bg-chem px-4 py-2 text-center" data-id="element-240" data-mp="3sdn83mb5k8gk">
      <p className="text-[11px] font-medium leading-snug text-white sm:text-xs" data-id="element-241" data-mp="2359mkkfi45go">
        <span className="sm:hidden" data-id="element-242" data-mp="1y42d8gxpmy7w">🌍 Dostęp od razu • Materiały cyfrowe do pobrania</span>
        <span className="hidden sm:inline" data-id="element-243" data-mp="1t6k4aqjp0izw">
          🌍 Dostęp od razu • Materiały cyfrowe do pobrania • Dla nauczycieli chemii w Polsce
        </span>
      </p>
    </div>;
}